<template>
  <div>
    <my-table :title="title"
              :isAdd="isAdd"
              :searchParams="searchParams"
              :tableData="tableData"
              :isSearch="isSearch"
              @pageNumChange="pageNumChange"
              @search="search"
              @keyup.enter.native="keyup()">
      <div slot="table">
        <user-coupons-table :tableData="tableData.list" @view="view"></user-coupons-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import UserCouponsTable from "./ShareTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {newVue,getShareBySearch} from "../../network/user";

  export default {
    name: "ShareList",
    components: {UserCouponsTable, MyTable},
    data(){
      return {
        title: "支农列表",
        isAdd: false,
        isSearch: true,
        //搜索条件
        searchParams:[
          {
            key:"inviterShareCode",
            value:"分享码搜索"
          }
        ],
        //表格数据以及分页信息
        tableData: {},
        searchItems:[],
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href =  "/userCoupons/list";
      this.common.HeaderLocationTwo.name =  "支农列表"
      this.common.HeaderLocationThree.name = "支农列表"

      let shareCode = this.$route.params.shareCode;
      if (shareCode!=null){
        let item = {};
        item.value = "inviterShareCode";
        item.input = shareCode;
        this.searchItems[0] = item;
      }
      this.searchEasy(this.searchItems)
    },
    methods:{
      refresh(){
        getShareBySearch().then(res => {
          this.tableData = res.data
        })
      },
      pageNumChange(pageNum){
        this.searchEasy(this.searchItems,pageNum);
      },
      search(searchItems){
        this.searchItems = searchItems;
        this.searchEasy(searchItems)
      },
      searchEasy(searchItems,pageNum){
        let inviterShareCode = null;
        for (let i = 0;i<searchItems.length;i++){
          if (searchItems[i].value === "inviterShareCode"){
            inviterShareCode = searchItems[i].input
          }
        }
        getShareBySearch(inviterShareCode,pageNum).then(res => {
          this.tableData = res.data
        })
      },
      keyup(){
        this.searchEasy(this.searchItems);
      },
      view(id){
        this.$router.push("/user/data/"+id)
      }
    }
  }
</script>

<style scoped>

</style>
